export const GenerateNameFileWhenIsend = (props) => {
  let files = props.files

  const isAnArray = Array.isArray(files)
  if (files?.length > 0 && files !== null && isAnArray === true) {
    return (
      <div>
        {files.map((file, index) => (
          <div key={index}>
            <i className="star-icon-check star-icon me-2" />
            <div>{file.name}</div>
          </div>
        ))}
      </div>
    )
  }

  return <div>---</div>
}
